import content from "../data/content.json";
import { resolveAssetPath } from "../utils/content";
import "./Hero.css";

const fallbackWaveform = [0.22, 0.28, 0.34, 0.42, 0.56, 0.74, 0.56, 0.42, 0.34, 0.28, 0.22];
const heroContent = content.site?.hero ?? {};
const accentPattern = /(Tech-driven|Graphic Design|UI\/UX|Video editing)/gi;
const accentTokenPattern = /^(Tech-driven|Graphic Design|UI\/UX|Video editing)$/i;

const openResume = () => {
  const resume = resolveAssetPath(heroContent.resume);

  if (resume) {
    window.location.href = resume;
  }
};

function Hero({ hasPlayableSong, isPlaying, onTogglePlayback, song, waveform }) {
  const mobileWaveform = waveform?.length ? waveform : fallbackWaveform;
  const roles = heroContent.roles?.length ? heroContent.roles : ["Web Developer", "Designer", "Video Editor"];
  const intro = heroContent.intro || "Hi Im,";
  const name = heroContent.name || "AKHIL";
  const desktopBio =
    heroContent.bio ||
    "Hi, I'm Akhil a creative and Tech-driven person who enjoys building things that look good and work even better.";
  const mobileBio = heroContent.mobileBio || desktopBio;
  const portraitSrc = resolveAssetPath(heroContent.portrait);

  const musicLabel = song
    ? `${isPlaying ? "Pause" : "Play"} ${song.title}${song.artist ? ` by ${song.artist}` : ""}`
    : "Song coming soon";

  const renderBioWithAccent = (bioText) =>
    bioText.split(accentPattern).map((chunk, index) =>
      accentTokenPattern.test(chunk) ? <span key={`${chunk}-${index}`}>{chunk}</span> : chunk
    );

  return (
    <>
      <section className="hero" id="home">
        <div className="hero-left">
          <h1 className="intro">{intro}</h1>

          <div className="name-box">
            <h1>{name}</h1>
          </div>

          <p className="mobile-role-list">
            {roles.map((role, index) => (
              <span key={role}>
                {role}
                {index < roles.length - 1 ? <br /> : null}
              </span>
            ))}
          </p>

          <p className="desc">
            {renderBioWithAccent(desktopBio)}
          </p>

          <button className="resume-btn" type="button" onClick={openResume}>
            RESUME
          </button>
        </div>

        <div className="hero-right">
          <button
            type="button"
            className={`music-pill ${isPlaying ? "is-playing" : ""}`}
            aria-label={musicLabel}
            aria-pressed={isPlaying}
            disabled={!hasPlayableSong}
            onClick={onTogglePlayback}
          >
            <span className="music-pill-label">
              {song
                ? `${isPlaying ? "PAUSE" : "PLAY"} ${song.title}${song.artist ? ` - ${song.artist}` : ""}`
                : "TO ADD MY FAV SONG"}
            </span>
            <span className="music-pill-wave" aria-hidden="true">
              {mobileWaveform.map((level, index) => (
                <span
                  key={index}
                  className="music-pill-wave-bar"
                  style={{ "--bar-scale": level }}
                />
              ))}
            </span>
          </button>

          <div className="arch-wrapper">
            <div className="arch-bg">
              {portraitSrc ? <img src={portraitSrc} alt={name} /> : <div className="profile-placeholder" />}
            </div>
          </div>
        </div>
      </section>

      <section className="hero-bio-mobile">
        <p className="hero-bio-text">{renderBioWithAccent(mobileBio)}</p>
        <button className="resume-btn-mobile" type="button" onClick={openResume}>
          RESUME
        </button>
      </section>
    </>
  );
}

export default Hero;
